import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAllSmsMessagesQueryVariables = Types.Exact<{
  moveIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetAllSmsMessagesQuery = { __typename?: 'query_root', smsmessages: Array<{ __typename?: 'smsmessages', id: number, move_id?: number | null, recipient_phone?: string | null, sender_phone?: string | null, message_body?: string | null, createdat?: string | null, updatedat?: string | null, status?: string | null, direction: string, createdby?: string | null }>, moves: Array<{ __typename?: 'moves', id: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, reference_num?: string | null, status?: string | null, cancel_status?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, ready_by?: string | null, lite: boolean }> };


export const GetAllSmsMessagesDocument = gql`
    query getAllSmsMessages($moveIds: [bigint!]!) {
  smsmessages(where: {move_id: {_in: $moveIds}}, order_by: {createdat: desc}) {
    id
    move_id
    recipient_phone
    sender_phone
    message_body
    createdat
    updatedat
    status
    direction
    createdby
  }
  moves(where: {id: {_in: $moveIds}}) {
    id
    consumer_name
    consumer_phone
    consumer_pickup
    reference_num
    status
    cancel_status
    vehicle_color
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    ready_by
    lite
  }
}
    `;

/**
 * __useGetAllSmsMessagesQuery__
 *
 * To run a query within a React component, call `useGetAllSmsMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSmsMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSmsMessagesQuery({
 *   variables: {
 *      moveIds: // value for 'moveIds'
 *   },
 * });
 */
export function useGetAllSmsMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables> & ({ variables: GetAllSmsMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>(GetAllSmsMessagesDocument, options);
      }
export function useGetAllSmsMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>(GetAllSmsMessagesDocument, options);
        }
// @ts-ignore
export function useGetAllSmsMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>;
export function useGetAllSmsMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSmsMessagesQuery | undefined, GetAllSmsMessagesQueryVariables>;
export function useGetAllSmsMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>(GetAllSmsMessagesDocument, options);
        }
export type GetAllSmsMessagesQueryHookResult = ReturnType<typeof useGetAllSmsMessagesQuery>;
export type GetAllSmsMessagesLazyQueryHookResult = ReturnType<typeof useGetAllSmsMessagesLazyQuery>;
export type GetAllSmsMessagesSuspenseQueryHookResult = ReturnType<typeof useGetAllSmsMessagesSuspenseQuery>;
export type GetAllSmsMessagesQueryResult = Apollo.QueryResult<GetAllSmsMessagesQuery, GetAllSmsMessagesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (smsmessages, moves): returns the full response object.
 * @source {@link src/features/moves/queries/getAllSmsMessages.query.gql}
 */
export async function getAllSmsMessages(
  variables: GetAllSmsMessagesQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetAllSmsMessagesQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetAllSmsMessagesQuery>(
    GetAllSmsMessagesDocument,
    variables,
    requestOptions
  )
}